import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { Login } from "./pages/Login/Login";
import { Navbar } from "./common/Navbar/Navbar";
import { Table } from "./pages/table/Table";
import { UserProvider } from "./context/user-context";
import { Navbar_loggedin } from "./common/Navbar/Navbar-loggedin";
import { AdminLogin } from "./pages/AdminLogin/AdminLogin";

const router = createBrowserRouter([
	{
		path: "/",
		element: (
			<div>
				<Navbar />
				<Login />
			</div>
		)
	},
	{
		path: "/admin",
		element: (
			<div>
				<Navbar></Navbar>
				<AdminLogin />
			</div>
		)
	},
	{
		path: "/table",
		element: (
			<div>
				<Navbar_loggedin />
				<Table />
			</div>
		)
	}
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<React.StrictMode>
		<UserProvider>
			<RouterProvider router={router} />
		</UserProvider>
	</React.StrictMode>
);
